import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as HomeSettingsActionCreators from "../../../actions/homeSettings.actions";
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';
import HomeSettings from '../Home/HomeSettings';
import AboutUsSettings from '../AboutUs/AboutUsSettings';
import ContactUsSettings from '../ContactUs/ContactUsSettings';

export interface IContentSettingsProps {
}

interface IContentSettingsState {
    selection: string;
    selections: any[];
}

class ContentSettings extends React.Component<IContentSettingsProps, IContentSettingsState> {
    constructor(props: IContentSettingsProps) {
        super(props);
        this.state = {
            selection: "home",
            selections: [
                { id: "home", label: "Home" },
                { id: "aboutus", label: "About Us" },
                { id: "contactus", label: "Contact Us" }
            ],
        };
    }


    render() {
        let content;
        let self = this;

        if (this.state.selection == "home") {
            content = <HomeSettings />
        } else if (this.state.selection == "aboutus") {
            content = <AboutUsSettings />
        } else if (this.state.selection == "contactus") {
            content = <ContactUsSettings />
        }

        console.log(content)

        let categories = (
            <div className="input-group">
                <fieldset className="form-group">
                    {this.state.selections.map((item) => (
                        <div className="form-check" key={"category" + item.id}>
                            <label className="form-check-label">
                                <input type="radio" className="form-check-input"
                                    name="optionsCategories"
                                    id={"category" + item.id}
                                    onClick={() => this.setState({ selection: item.id })}
                                    checked={this.state.selection == item.id} />
                                &nbsp;&nbsp;{item.label}
                            </label>
                        </div>
                    ))}
                </fieldset>
            </div>
        );



        return (
            <div className="row fixed-scrolling-side">
                <div className="col-12 col-lg-3 pl-md-0 mb-3 discussion-board sidebar">
                   
                    <div className="sidebar-actions-lg">
                        {categories}
                    </div>
                </div>
                <div className="col-12 col-lg-9">
                    <div className="discussion-board-resource">
                        <div className="row">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
        },
        dispatch
    );
};


const ContentSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(
    ContentSettings
);

export default ContentSettingsContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/Content/ContentSettings.tsx